import { Controller } from "@hotwired/stimulus"

/**
 * Payment Failure Modal controller that shows a non-dismissable modal
 * when the user's payment has failed.
 *
 * Usage:
 *   <div data-controller="payment-failure-modal"
 *        data-payment-failure-modal-excluded-paths-value='["/profile", "/settings/billing"]'>
 *     <div id="paymentFailureModal" class="modal fade" ...>
 *   </div>
 */
export default class PaymentFailureModalController extends Controller<HTMLElement> {
  static values = {
    excludedPaths: Array
  }

  declare readonly excludedPathsValue: string[]

  connect(): void {
    // Don't show modal on excluded pages (profile, billing settings)
    if (this.excludedPathsValue.includes(window.location.pathname)) {
      return
    }

    const modalElement = this.element.querySelector(".modal")
    if (!modalElement) return

    const modal = new globalThis.bootstrap.Modal(modalElement, {
      backdrop: "static",
      keyboard: false
    })
    modal.show()
  }
}
